import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Components/Modal/ModalComponent.component';
import PrimaryButtonComponent from '../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { httpSignupNewsletter } from '../Hooks/newsletter/newsletter.post.hooks';
import { NewsletterFormCentered } from './Newsletters.styles';
import {
  NewsletterModalContent,
  NewsletterModalFinePrint,
  NewsletterModalStatus,
} from './NewsletterModal.styles';

const NewsletterModal = ({ setShowEmailModal }) => {
  const [email, setEmail] = useState('');
  const [honeypot, setHoneypot] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Bot likely filled the hidden field
    if (honeypot) {
      setStatus('You have been signed up for our newsletter!');
      return;
    }

    try {
      const res = await httpSignupNewsletter(email.trim(), honeypot);
      const data = await res.json();

      if (res.ok) {
        setStatus(data.msg || 'You have been signed up for our newsletter!');
      } else {
        setStatus(data.msg || 'Failed to sign up for the newsletter');
      }
    } catch (err) {
      setStatus('An error occurred. Please try again.');
    }
  };

  return (
    <Modal onClose={() => setShowEmailModal(false)} showClose="false">
      <NewsletterModalContent>
        <p className="eyebrowHeader">Safety Updates</p>

        <h2>Join Our Safety Newsletter</h2>

        <p className="modalIntro">
          Get monthly updates on workplace safety, training opportunities,
          compliance reminders, and industry resources.
        </p>

        <NewsletterFormCentered onSubmit={handleSubmit}>
          <input
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            type="email"
            required
          />

          {/* Honeypot field - hidden from real users */}
          <div
            aria-hidden="true"
            style={{
              position: 'absolute',
              left: '-9999px',
              width: '1px',
              height: '1px',
              overflow: 'hidden',
            }}
          >
            <label htmlFor="website">Website</label>
            <input
              id="website"
              name="website"
              type="text"
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
              tabIndex="-1"
              autoComplete="off"
            />
          </div>

          <PrimaryButtonComponent span="Subscribe" />
        </NewsletterFormCentered>

        <NewsletterModalFinePrint>
          You can unsubscribe at any time. We respect your privacy and will
          never share your email.
        </NewsletterModalFinePrint>

        {status && (
          <NewsletterModalStatus $success={status.includes('success')}>
            {status}
          </NewsletterModalStatus>
        )}
      </NewsletterModalContent>
    </Modal>
  );
};

NewsletterModal.propTypes = {
  setShowEmailModal: PropTypes.func,
};

export default NewsletterModal;
